import { MARQUEE_ITEMS } from "../data/site";

export const Marquee = () => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div data-testid="brand-marquee" className="overflow-hidden bg-burgundy py-4" aria-hidden="true">
      <div className="marquee-track flex w-max animate-marquee items-center">
        {items.map((item, i) => (
          <span key={i} className="flex items-center whitespace-nowrap">
            <span className="font-display text-lg italic text-cream sm:text-xl">{item}</span>
            <span className="mx-8 inline-block h-1.5 w-1.5 rounded-full bg-gold" />
          </span>
        ))}
      </div>
    </div>
  );
};
